import { Controller } from "@hotwired/stimulus"
import { session } from "@hotwired/turbo"

const THRESHOLD = 80

export default class extends Controller {
  connect() {
    this.startY = 0
    this.pulling = false
    this.currentDistance = 0

    this.indicator = document.createElement("div")
    this.indicator.className = "pull-to-refresh-indicator"
    this.indicator.textContent = "\u2193"
    this.element.prepend(this.indicator)

    this.element.addEventListener("touchstart", this.onTouchStart, { passive: true })
    this.element.addEventListener("touchmove", this.onTouchMove, { passive: false })
    this.element.addEventListener("touchend", this.onTouchEnd, { passive: true })
  }

  disconnect() {
    this.element.removeEventListener("touchstart", this.onTouchStart)
    this.element.removeEventListener("touchmove", this.onTouchMove)
    this.element.removeEventListener("touchend", this.onTouchEnd)
    this.indicator.remove()
  }

  onTouchStart = (event) => {
    if (this.element.scrollTop === 0) {
      this.startY = event.touches[0].clientY
      this.pulling = true
    }
  }

  onTouchMove = (event) => {
    if (!this.pulling) return

    const distance = event.touches[0].clientY - this.startY
    if (distance < 0) {
      this.pulling = false
      this.currentDistance = 0
      this.setIndicator(0)
      return
    }

    if (distance > 0 && this.element.scrollTop === 0) {
      event.preventDefault()
    }

    this.currentDistance = Math.min(distance, THRESHOLD * 1.5)
    this.setIndicator(this.currentDistance)

    this.indicator.textContent = this.currentDistance >= THRESHOLD ? "\u2191" : "\u2193"
  }

  onTouchEnd = () => {
    if (!this.pulling) return

    const shouldRefresh = this.currentDistance >= THRESHOLD
    this.pulling = false
    this.currentDistance = 0
    this.setIndicator(0)

    if (shouldRefresh) {
      this.element.style.opacity = "0.5"
      document.addEventListener("turbo:render", () => {
        this.element.style.opacity = "1"
      }, { once: true })
      session.refresh(window.location.href)
    }
  }

  setIndicator(distance) {
    this.indicator.style.height = `${distance}px`
    this.indicator.style.opacity = Math.min(distance / THRESHOLD, 1)
  }
}
